import React from "react"

function Shop({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 8H26L28 16"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 8H10L8 16"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 16C8 17.1 9.5 18 11.5 18C13.5 18 15 17.1 15 16C15 17.1 16.5 18 18 18C19.5 18 21 17.1 21 16C21 17.1 22.5 18 24.5 18C26.5 18 28 17.1 28 16"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 18V27C9 27.55 9.45 28 10 28H26C26.55 28 27 27.55 27 27V18"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line x1="14" y1="8" x2="14" y2="13" stroke="#003E4C" strokeWidth="1" strokeLinecap="round" />
      <line x1="22" y1="8" x2="22" y2="13" stroke="#003E4C" strokeWidth="1" strokeLinecap="round" />
    </svg>
  )
}
export default Shop
